export default {
  temporaryrequest: {
    name: 'คิวสำรอง',
    edit: { title: 'แก้ไขคิวสำรอง' },
    fields: {
      book_id: 'หมายเลขนัดหมาย',
      title: 'รหัส, ชื่อ, นามสกุล, เบอร์ หรือ อีเมล',
      name: 'ชื่อ-นามสกุล',
      first_name: 'ชื่อ',
      last_name: 'นามสกุล',
      tel: 'เบอร์',
      email: 'อีเมล',
      license_plate: 'ทะเบียนรถ',
      license_plate_province: 'จังหวัด',
      code: 'รหัส',
      branch_code: 'สาขา',
      fname_lname: 'ชื่อ / นามสกุล',
      status: {
        label: 'สถานะ',
        choices: {
          confirm: 'ยืนยันนัดหมาย',
          cancel: 'ยกเลิก',
          pending: 'รอดำเนินการ',
          reserve: 'จอง',
          temporary_request: 'ขอคิวสำรอง',
          complete: 'เสร็จสิ้น',
        },
      },
      cancel_reason: {
        label: 'เหตุผลในการยกเลิก',
        message: 'ระบุเหตุผล',
        choices: {
          sold_out: 'สินค้าขาดตลาด',
          inconvenience: 'ลูกค้าไม่สะดวกเข้ารับบริการ',
          other: 'อื่นๆ',
        },
      },
      booking_date: 'วันที่จอง',
      create_at: 'วัน-เวลาที่สร้าง',
      start_date: 'เวลาเริ่มต้น',
      end_date: 'เวลาสิ้นสุด',
      more_detail: 'รายละเอียดเพิ่มเติม',
      is_accept_terms_conditions: 'ยอมรับเงื่อนไข',
      is_active: 'ใช้งาน',
      booking_slot: 'ช่อง',
      start_time: 'เวลาเริ่มต้น',
      end_time: 'เวลาสิ้นสุด',
      car_brand: 'แบรนด์รถยนต์',
      car_model: 'รุ่นรถยนต์',
      service: 'บริการ',
      show: { title: 'รายละเอียดการจอง' },
    },
  },
}
